export default __webpack_public_path__ + "static/media/crisp.209e85f2.svg";